import { render, staticRenderFns } from "./PqtProductTestEditModal.vue?vue&type=template&id=2b318e9c"
import script from "./PqtProductTestEditModal.vue?vue&type=script&lang=ts"
export * from "./PqtProductTestEditModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports